import styled from 'styled-components';

interface StickyDivProps {
  backgroundColor?: string;
  bottom?: string;
  marginBottom?: string;
  marginTop?: string;
  padding?: string;
  position?: string;
  top?: string;
}

const StickyDiv = styled.div<StickyDivProps>`
  position: ${({ position }) => position || 'sticky'};
  display: flex;
  left: 0;
  top: ${({ top }) => top || '64px'};
  ${({ bottom }) => (bottom ? `bottom: ${bottom};` : null)}
  margin-left: -40px;
  margin-top: -30px;
  ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop};` : null)}
  ${({ marginBottom }) => (marginBottom ? `margin-bottom: ${marginBottom};` : null)}
  padding: ${({ padding }) => padding || '30px 0 30px'};
  background: ${({ backgroundColor }) => backgroundColor || 'white'};
  width: 100vw;
  z-index: 500;
`;

export { StickyDiv };
